var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChatBubble = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#chat-bubble_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.75 10.529h6.5v-.857c0-.487-.313-.902-.938-1.243-.624-.341-1.395-.512-2.312-.512-.917 0-1.688.17-2.313.512-.625.341-.937.756-.937 1.243v.857Zm3.254-3.51c.414 0 .767-.148 1.059-.443.291-.296.437-.651.437-1.066a1.44 1.44 0 0 0-.442-1.061 1.454 1.454 0 0 0-1.062-.439c-.414 0-.767.148-1.059.443-.291.296-.437.65-.437 1.066 0 .415.147.768.442 1.061.294.293.649.439 1.062.439ZM3 13.537 1.273 15.27c-.237.239-.51.292-.815.161C.153 15.3 0 15.065 0 14.73V2.004c0-.413.147-.768.44-1.062A1.442 1.442 0 0 1 1.5.5h13c.412 0 .766.147 1.06.442.293.294.44.649.44 1.062v10.03c0 .413-.147.767-.44 1.062a1.442 1.442 0 0 1-1.06.441H3Zm-.625-1.504H14.5V2.004h-13v10.907l.875-.878Z",
  fill: "currentColor"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "chat-bubble_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h16v16H0z"
})))));
export default SvgChatBubble;